module.exports = __webpack_public_path__ + "static/img/getimage.5b94de9.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home_model/getimage.png
// module id = sigu
// module chunks = 74